import React from 'react';
import BaseLayout from './BaseLayout';

const PrivateLayout: React.FC = () => <BaseLayout showTitle showMenu />;

export default PrivateLayout;
